/* slider */
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
/* animations */
import anime from "animejs";

document.addEventListener("DOMContentLoaded", function () {
  /* const swiper = */ new Swiper(".swiper", {
    modules: [Navigation],
    loop: true,
    slidesPerView: 1,
    direction: "horizontal",
    spaceBetween: 0,
    navigation: {
      nextEl: ".my-swiper-button-next",
      prevEl: ".my-swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
      1280: {
        slidesPerView: 2,
        spaceBetween: 70,
      },
      1536: {
        slidesPerView: 2,
        spaceBetween: 110,
      },
    },
  });
});

document.addEventListener("DOMContentLoaded", function () {
  let isOpen = false;

  const idOpenButton = "mobile-menu-open";
  const idCloseButton = "mobile-menu-close";
  const idBackdrop = "mobile-menu-backdrop";
  const idLayout = "mobile-menu-layout";
  const classMenuItems = ".mobile-menu-item";

  const openButton = document.getElementById(idOpenButton);
  const closeButton = document.getElementById(idCloseButton);
  const backdrop = document.getElementById(idBackdrop);
  const layout = document.getElementById(idLayout);
  const menuItems = document.querySelectorAll(classMenuItems);

  const animationClose = anime
    .timeline({
      targets: menuItems,
      easing: "easeInOutExpo",
      opacity: [1, 0],
      duration: 400,
      autoplay: false,
      complete: function () {
        isOpen = false;
      },
    })
    .add(
      {
        targets: layout,
        easing: "easeInOutExpo",
        height: ["100%", 0],
        duration: 600,
      },
      "+=200"
    )
    .add(
      {
        targets: backdrop,
        easing: "easeInOutExpo",
        opacity: [1, 0],
        duration: 400,
      },
      "-=100"
    )
    .add(
      {
        targets: backdrop,
        easing: "easeInOutExpo",
        height: ["100%", 0],
        duration: 100,
      },
      "+=200"
    );

  const animationOpen = anime
    .timeline({
      targets: backdrop,
      easing: "easeInOutExpo",
      autoplay: false,
      height: [0, "100%"],
      duration: 1,
      complete: function () {
        isOpen = true;
      },
    })
    .add({
      targets: backdrop,
      easing: "easeInOutExpo",
      height: [0, "100%"],
      opacity: [0, 1],
      duration: 200,
    })
    .add(
      {
        targets: layout,
        easing: "easeInOutExpo",
        height: [0, "100%"],
        opacity: [0, 1],
        duration: 600,
      },
      "-=100"
    )
    .add(
      {
        targets: menuItems,
        easing: "easeInOutExpo",
        translateY: ["-100px", 0],
        opacity: [0, 1],
        duration: 400,
        delay: function (el, i, l) {
          return i * 100;
        },
      },
      "-=400"
    );

  // sets the animation
  openButton.onclick = function () {
    if (!isOpen) {
      animationOpen.play();
    }
  };

  // sets the animation
  closeButton.onclick = function () {
    if (isOpen) {
      animationClose.play();
    }
  };
});
